export function getLocalPaginatedList<T>(list: Array<T>, page = 1, perPage = 10) {  
  return [...list].splice((page - 1) * perPage, perPage)
}

export function getTotalPages(totalRecords: number, perPage: number) {
  return Math.ceil(totalRecords / perPage)
}
